import { Alert, Button } from "@mui/material";
import React from "react";
import { EmailMethod } from "../api/types";
import { useGlobalState } from "../components/globalState";

const providerSlug = (method: EmailMethod | undefined): string => {
	if (method === EmailMethod.OUTLOOK) return "outlook";
	if (method === EmailMethod.GMAIL) return "gmail";
	return "imap";
};

export const EmailSyncFailureBanner: React.FC = () => {
	const { currentUser } = useGlobalState();
	const profile = currentUser?.userprofile;
	const lastError = profile?.email_sync_last_error;

	if (!lastError) return null;

	const slug = providerSlug(profile?.email_method);
	const settingsHref =
		slug === "outlook" ? "/config/outlook" : `/config/email/${slug}`;

	return (
		<Alert
			severity="error"
			data-component="email-sync-failure-banner"
			action={
				<Button color="inherit" size="small" href={settingsHref}>
					Fix credentials
				</Button>
			}
		>
			Email sync failed: {lastError}
		</Alert>
	);
};
